<div class="progress-spinner syn-card-list__footer">
    <ng-container *ngIf="loading">
        <mat-spinner [diameter]="24" color="primary"></mat-spinner>
        <span class="mat-headline-5">{{ textLoading }}</span>
    </ng-container>

    <div *ngIf="!loading && empty" fxLayout="row" fxLayoutAlign="center center">
        {{ textEmpty }}
    </div>

    <div *ngIf="!loading && active && !allLoaded">
        <button mat-button (click)="loadMore()">
            <mat-icon svgIcon="plus-circle-outline"></mat-icon>
            {{ textLoadMore }}
        </button>
    </div>

    <div *ngIf="!loading && !empty && active && allLoaded" fxLayout="row" fxLayoutAlign="center center">
        {{ textAllLoaded }}
    </div>
</div>
